(function () {
    'use script';

    angular
        .module(app.modules.common.name)
        .constant('equipmentClubType', createEquipmentClubType());

    function createEquipmentClubType() {
        return angular.createEnum({
            Driver: [1, 'Driver'],
            Wood2: [2, '2 Wood'],

            Wood3: [3, '3 Wood'],
            Wood4: [4, '4 Wood'],
            Wood5: [5, '5 Wood'],
            Wood6: [6, '6 Wood'],
            Wood7: [7, '7 Wood'],
            Wood8: [8, '8 Wood'],
            Wood9: [9, '9 Wood'],

            Hybrid1: [10, '1 Hybrid'],
            Hybrid2: [11, '2 Hybrid'],
            Hybrid3: [12, '3 Hybrid'],
            Hybrid4: [13, '4 Hybrid'],
            Hybrid5: [14, '5 Hybrid'],
            Hybrid6: [15, '6 Hybrid'],
            Hybrid7: [16, '7 Hybrid'],
            Hybrid8: [17, '8 Hybrid'],
            Hybrid9: [18, '9 Hybrid'],

            Iron1: [19, '1 Iron'],
            Iron2: [20, '2 Iron'],
            Iron3: [21, '3 Iron'],
            Iron4: [22, '4 Iron'],
            Iron5: [23, '5 Iron'],
            Iron6: [24, '6 Iron'],
            Iron7: [25, '7 Iron'],
            Iron8: [26, '8 Iron'],
            Iron9: [27, '9 Iron'],

            PitchingWedge: [28, 'Pitching Wedge'],
            GapWedge: [29, 'Gap Wedge'],
            SandWedge: [30, 'Sand Wedge'],
            LobWedge: [31, 'Lob Wedge'],
            Putter: [32, 'Putter'],

            Wood: [33, 'Wood'],
            Hybrid: [34, 'Hybrid'],
            Iron: [35, 'Iron'],
            Wedge: [36, 'Wedge']
        });
    };
})();